import { formatCurrency } from '@/services/convert'
import { createTreeData } from '@/services/grid'
import { instance, errorService } from '@/services/api'
import { projectAPIs } from '@/services/authConstantsV1'
import { showNotification } from '@/services/calculate'
import _ from 'lodash'
import TreeTable from 'primevue/treetable'
import Column from 'primevue/column'
import Checkbox from 'primevue/checkbox'
import axios from 'axios'

export default {
  components: {
    'tree-table': TreeTable,
    column: Column,
    checkbox: Checkbox,
  },
  props: ['indirectCostId', 'assetId', 'actualCost'],
  data: function() {
    return {
      visible: false,
      loading: true,
      formatCurrency: formatCurrency,
      treeData: [],
      tempTreeData: [],
      selectedNodes: undefined,
      checkAll: false,
      keyCount: null,
      addFrom: 'Estimate Group',
      filters: {},
      width: '110rem',
      padding: '0px',
      bodyWidth: '35rem',
      showCheckbox: true,
      levelList: [],
      groupList: [],
      list: [],
      searchId: undefined,
      searchName: undefined,
      estimateMethod: undefined,
    }
  },
  beforeMount() {
    this.visible = true
    this.loadDropdown()
    window.addEventListener('resize', this.detectViewPortListener)
  },
  methods: {
    handleCancel() {
      this.visible = false
      this.addFrom = 'Estimate Group'
      this.treeData = []
      this.selectedNodes = undefined
      this.searchId = undefined
      this.estimateMethod = undefined
      this.checkAll = false
      this.$emit('onClose', false)
    },

    onChange(value) {
      let type
      switch (value) {
        case 'Standard':
          type = 'standard'
          this.list = this.levelList
          break
        case 'Estimate Group':
          type = 'estimate'
          this.list = this.groupList
          break

        default:
          break
      }
      this.searchId = undefined
      this.checkAll = false
      this.treeData = []
      this.tempTreeData = []
      this.keyCount = null
      this.selectedNodes = undefined
      if (this.list.length > 0) {
        this.searchId = this.list[0].id
        this.searchName = this.list[0].name
        this.estimateMethod = this.list[0].estimateMethod
      }
      this.getTakeoffs(type, value)
    },

    onSelect(value) {
      const data = this.list.find(i => i.name === value)
      if (data) {
        this.checkAll = false
        this.selectedNodes = undefined
        this.searchId = data.id
        this.estimateMethod = data.estimateMethod
        const filterData = [...this.tempTreeData]
        this.treeData = []
        this.treeData = filterData.filter(
          i => i.key.split(' ~ ')[0] === String(this.searchId),
        )
        this.hideCheckbox()
      }
    },

    loadDropdown() {
      Promise.all([this.loadEstimateGroups(), this.loadLevels()])
        .then(
          axios.spread((...responses) => {
            this.levelList = []
            this.groupList = []
            this.groupList.push({
              id: _.get(responses[0].data, 'result..id', 0),
              name: _.get(
                responses[0].data,
                'result.estimateGroupName',
                'Flattened View',
              ),
            })
            _.get(responses[0].data, 'result.estimateGroup', []).forEach(
              group => {
                this.groupList.push({
                  id: group.id,
                  name: `${group.estimateGroupName} (${
                    group.estimateMethod === 1 ? 'Variance' : 'Residual'
                  })`,
                  estimateMethod: group.estimateMethod,
                })
              },
            )
            _.get(responses[1].data, 'result', []).forEach(level => {
              this.levelList.push({
                id: level.id,
                name: level.levelName,
              })
            })
            this.list = [...this.groupList]
            if (this.list.length > 0) {
              this.searchId = this.list[0].id
              this.searchName = this.list[0].name
            }
            this.loading = false
            this.getTakeoffs('estimate', 'Estimate Group')
          }),
        )
        .catch(error => {
          this.loading = false
          errorService(error)
        })
    },

    loadLevels() {
      return instance.get(
        projectAPIs.project.asset.actualCost.level.details(
          this.$route.params.id,
          this.assetId,
        ),
      )
    },

    loadEstimateGroups() {
      return instance.get(
        projectAPIs.project.asset.estimate.list(
          this.$route.params.id,
          this.assetId,
        ),
      )
    },

    createTreeData(value, data) {
      const treeData = createTreeData(data, value, this.list)
      this.tempTreeData = treeData.treeData
      const filterData = [...this.tempTreeData]
      this.treeData = []
      this.treeData = filterData.filter(
        i => i.key.split(' ~ ')[0] === String(this.searchId),
      )
      this.keyCount = treeData.treeKeys
      this.bodyWidth = 'auto'
      this.hideCheckbox()
    },

    getTakeoffs(addFrom, type) {
      this.loading = true
      const url = projectAPIs.project.asset.indirectCost.costDetails[addFrom](
        this.$route.params.id,
        this.assetId,
      )
      instance
        .get(url)
        .then(response => {
          this.loading = false
          const data = _.get(response.data, 'result', [])
          this.createTreeData(type, data)
        })
        .catch(err => {
          this.loading = false
          errorService(err)
        })
    },

    selectAll(event) {
      if (this.checkAll) {
        const selectedata = []
        const treeData = this.treeData
        treeData.map(data => {
          selectedata[data.key] = { checked: true, partialChecked: false }
          if (data.children) {
            data.children.map(firstLevel => {
              selectedata[firstLevel.key] = {
                checked: true,
                partialChecked: false,
              }
              if (firstLevel.children) {
                firstLevel.children.map(secondLevel => {
                  selectedata[secondLevel.key] = {
                    checked: true,
                    partialChecked: false,
                  }
                  if (secondLevel.children) {
                    secondLevel.children.map(thirdLevel => {
                      selectedata[thirdLevel.key] = {
                        checked: true,
                        partialChecked: false,
                      }
                      if (thirdLevel.children) {
                        thirdLevel.children.map(fourthLevel => {
                          selectedata[fourthLevel.key] = {
                            checked: true,
                            partialChecked: false,
                          }
                        })
                      }
                    })
                  }
                })
              }
            })
            this.selectedNodes = selectedata
          }
        })
      } else {
        this.selectedNodes = undefined
      }
    },

    onNodeSelect(node) {
      this.checkAll =
        this.keyCount[this.searchId] === Object.keys(this.selectedNodes).length
    },

    onNodeUnselect(node) {
      if (_.isEmpty(this.selectedNodes)) {
        this.selectedNodes = undefined
      } else if (Object.keys(this.selectedNodes).length > 0) {
        if (
          Object.keys(this.selectedNodes).every(
            i => !this.selectedNodes[i].checked,
          )
        ) {
          this.selectedNodes = undefined
        }
      }
      this.checkAll = false
    },

    onNodeExpand(node) {
      this.hideCheckbox()
    },

    addTakeoffs() {
      if (
        this.estimateMethod &&
        this.estimateMethod === 2 &&
        this.actualCost < 0
      ) {
        showNotification(
          'warning',
          'Assign Indirect',
          'You can not assign cost details because calculation will turn into negative value!',
        )
        return
      }
      let isValid = false
      const request = []
      let data = null
      const url = projectAPIs.project.asset.indirectCost.costDetails.add(
        this.$route.params.id,
        this.assetId,
        this.indirectCostId,
      )
      if (Object.keys(this.selectedNodes).length > 0) {
        let nodes = { ...this.selectedNodes }
        nodes = Object.keys(this.selectedNodes).filter(
          i => i.split(' ~ ').length > 5,
        )
        nodes.forEach(key => {
          const splitKey = key.split(' ~ ')
          if (splitKey && splitKey.length === 6) {
            if (this.selectedNodes[key].checked) {
              data = JSON.parse(splitKey[5])
              isValid = true
            }
          } else if (splitKey && splitKey.length === 7) {
            if (this.selectedNodes[key].checked) {
              data = JSON.parse(splitKey[6])
              isValid = true
            }
          }
          if (data) {
            request.push({
              actualTakeoffId: data.actualTakeoffId,
              estimateTakeoffId: data.estimateTakeoffId,
              mCategoryCodeId: data.mCategoryCodeId,
              mContractId: data.mContractId,
              mUnitId: data.mUnitId,
              mTakeoffId: data.mTakeoffId,
              mTakeoffGroupingId: data.mTakeoffGroupingId,
              mCostTypeId: data.mCostTypeId,
              mCostMethodId: data.mCostMethodId,
              unitCost:
                data.costType === 'Estimate' ? data.trendedCost : data.unitCost,
              takeoff: data.takeoff,
              note: data.note,
              quantity: data.quantity,
              isValidTakeoff: data.isValidTakeoff,
            })
          }
        })
      }
      if (isValid && request.length > 0) {
        this.loading = true
        instance
          .post(url, request)
          .then(response => {
            this.loading = false
            this.checkAll = false
            this.selectedNodes = undefined
            this.$emit(
              'getLineItems',
              _.get(response.data, 'result', []),
              this.indirectCostId,
            )
          })
          .catch(err => {
            this.loading = false
            errorService(err)
          })
      }
    },

    detectViewPortListener() {
      if (window.innerWidth > 1450) {
        this.width = '110rem'
        this.padding = '0px !important'
      } else if (window.innerWidth < 1450) {
        this.width = '100%'
        this.padding = '10px !important'
      } else {
        this.width = '110rem'
        this.padding = '0px !important'
      }
    },

    onFilter() {
      if (this.filters && this.filters.global) {
        this.showCheckbox = false
        this.checkAll = false
        this.selectedNodes = undefined
      } else {
        this.showCheckbox = true
        this.hideCheckbox()
      }
    },

    hideCheckbox() {
      setTimeout(() => {
        const element = document.querySelectorAll('td')
        if (element) {
          const list = [...element].filter(i => i.innerText === 'Cost Type')
          list.forEach(node => {
            node.childNodes[1].classList.add('hide-checkbox')
          })
        }
      }, 50)
    },
  },
}
